module.exports = __webpack_public_path__ + "img/left-mid.6770d6ee.svg";